module.exports = __webpack_public_path__ + "img/30-days-badge-money-back.b663915e.svg";